import addPanel from './addPanel/addPanel';
import addPanelStyleManager from './addPanel/addPanelStyleManager';
import * as addPanelUtils from './addPanel/addPanelUtils';
import componentsDefaultData from './addPanel/componentsDefaultData';
import type {
  DraggableItem,
  OnDropCallback,
  DragHandlerHooks,
} from './addPanel/dragToStage/AddPanelDragHandler';
import addPanelDragToStage from './addPanel/dragToStage/addPanelDragToStage';
import dragBox from './addPanel/dragToStage/dragBox';
import anchorsNavigation from './anchorsNavigation/anchorsNavigation';
import { CategoryView as categoryView } from './categoryView/categoryView';
import { NewAddPanel as newAddPanel } from './newAddPanel/newAddPanel';
import { NewAddPanelSectionView as newAddPanelSectionView } from './newAddPanel/sectionView';
import baseGenerator from './sections/baseGenerator';
import * as dataSectionUtils from './sections/listSection/dataSectionUtils';
import * as imageSectionUtils from './sections/listSection/imageSectionUtils';
import designPanelLiveComponentSection from './sections/liveComponentsSections/designPanelLiveComponentSection';
import liveComponentSection from './sections/liveComponentsSections/liveComponentSection';
import * as liveComponentStyleAdjuster from './sections/liveComponentsSections/liveComponentStyleAdjuster';
import * as liveComponentUtils from './sections/liveComponentsSections/liveComponentUtils';
import { ThemeSection } from './sections/liveComponentsSections/themeSection';
import { PersonalizedSection } from './sections/liveComponentsSections/personalizedSection';
import * as liveComponentSectionUtils from './sections/liveComponentsSections/liveComponentSectionUtils';
import sectionWrapper from './sections/sectionWrapper';
import snapshotSection, {
  type ISnapshotSectionProps,
} from './sections/snapshotSection/snapshotSection';
import welcomeSection from './sections/welcomeSection/welcomeSection';
import * as mediaManagerUtils from './utils/mediaManager';
import * as mediaStudioUtils from './utils/mediaStudio';

export { onNewAddPanelReady } from './bootstrap';

export type { WelcomeSectionProps } from './sections/welcomeSection/welcomeSection';

export type {
  DraggableItem,
  ISnapshotSectionProps,
  OnDropCallback,
  DragHandlerHooks,
};
export type { CompFullStructure } from './sections/liveComponentsSections/componentCreationUtil';
export type {
  MainMenuItem,
  AdditionalImageData,
} from './addPanel/componentsDefaultData';
export { useNewAddPanelData } from './newAddPanel/useNewAddPanelData';

export {
  addPanel,
  newAddPanel,
  newAddPanelSectionView,
  anchorsNavigation,
  categoryView,
  baseGenerator,
  addPanelDragToStage,
  dragBox,
  imageSectionUtils,
  liveComponentStyleAdjuster,
  liveComponentUtils,
  liveComponentSection,
  ThemeSection,
  PersonalizedSection,
  liveComponentSectionUtils,
  componentsDefaultData,
  dataSectionUtils,
  addPanelStyleManager,
  designPanelLiveComponentSection,
  sectionWrapper,
  welcomeSection,
  snapshotSection,
  addPanelUtils,
  mediaManagerUtils,
  mediaStudioUtils,
};
